import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import Back from "shared/assets/images/svg/back_blue.svg";
import Company from "shared/assets/images/svg/company.svg";

const SignUpHome = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [navigateName, setNavigateName] = useState("company");

  function handelInput(id) {
    setNavigateName(id);
  }

  function handelNext() {
    if (navigateName === "company") {
      navigate("/signup/customer");
    } else if (navigateName === "driverRequest") {
      navigate("/signup/driver");
    }
  }

  return (
    <div className="signUpHome">
      <div className="container">
        <div className="page-header">
          <div className="header-info">
            <Link to="/">
              <img src={Back} alt="" />
            </Link>
            <h1 className="title">{t("signup.title")}</h1>
          </div>
        </div>
        <hr className="hr" />
        <div className="row">
          <div className="col-lg-6 col-md-8">
            <h3 className="title">
              {t("signup.sign-up-with-your-company-name-or-driver-identity")}
            </h3>
            <p className="p-content">
              {t("signup.by-clicking-on-sign-up-we-will-review-your-data")}{" "}
              <Link to="">{t("signup.terms-of-services")}</Link> {t("common.and")} {" "}
              <Link to="/">{t("signup.privacy-policies")}</Link>.
            </p>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-md-4">
            <div className="div-all">
              <input
                type="radio"
                id="company"
                checked={navigateName === "company"}
                name="signup"
                onClick={(e) => {
                  handelInput(e.target.id);
                }}
              />
              <label className="checkType" htmlFor="company">
                <div className="logo">
                  <img src={Company} alt="" />
                </div>
                <div className="content">
                  <h1>{t("signup.im-a-business-owner")}</h1>
                  <p>{t("signup.business-detail")}</p>
                </div>
              </label>
            </div>
          </div>
          <div className="col-md-4">
            <div className="div-all">
              <input
                type="radio"
                id="driverRequest"
                name="signup"
                checked={navigateName === "driverRequest"}
                onClick={(e) => {
                  handelInput(e.target.id);
                }}
              />
              <label className="checkType" htmlFor="driverRequest">
                <div className="logo">
                  <img src={Company} alt="" />
                </div>
                <div className="content">
                  <h1>{t("signup.im-a-driver")}</h1>
                  <p>{t("signup.driver-detail")}</p>
                </div>
              </label>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-md-8">
              <div className="row ">
                <div className="col-md-6">
                  <button className="btn-blue w-100" onClick={handelNext}>
                    {t("signup.next")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignUpHome;
